import { createContext } from "react";

export const SuggestedUserContext = createContext({});
